import React from 'react';
import title from './title.less'

class Title extends React.Component{
    constructor(props){
        super(props)
        this.state={

        }
    }
    render(){
        return(
            <div className='topTitle'>
                <p>
                {
                    this.props.title.secondTitle ?
                    <span><span style={{color:'rgba(0, 0, 0, 0.65)'}}>{this.props.title.firstTitle}</span>><span style={{color:'#001529'}}>{this.props.title.secondTitle}</span></span>
                    :
                    <span style={{color:'rgba(0, 0, 0, 0.65)'}}>{this.props.title.firstTitle}</span>
                }
                </p>
            </div>
        )
    }
}

export default Title


// WEBPACK FOOTER //
// ./src/compenents/title.js